import { ComponentChild } from 'preact';
import { ANIMATION_DURATION } from '../common';

export const MODAL_OPEN_CLASS = 'bw-modal-open';
export const MODAL_ANIMATION_DURATION: number = ANIMATION_DURATION;

export enum ModalStatus {
  OPEN = 'modal-open',
  CLOSING = 'modal-closing',
  CLOSED = 'modal-closed',
}

export interface ModalContext {
  modal: {
    showModal: (modal: ComponentChild, onClose?: () => any) => void;
    hideModal: () => void;
    horizontal: boolean;
  };
}
